// extracted by mini-css-extract-plugin
export default {"container":"rF-z","header":"sF-z","details":"tF-z","link":"uF-z"};